import React, { useEffect, useState } from 'react'
import { getMyListPostReported,changeMyListPostReported} from '../../actions/userActions';
import { connect } from 'react-redux'
import inMemoryJWT from '../../auth/inMemoryJwt';

const SeeMyPostReported = ({ getMyListPostReported, myListPostReported, isLoadingMyListPostReported, changeMyListPostReported, history }) => {
  
    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }
    
        inMemoryJWT.waitForTokenRefresh().then(() => {
            getMyListPostReported()
        })
        
    },[])

    console.log()
    return (
        <div>
            <div className='title-admin'>Post reportados</div>
            <div className='wrapper-2 centerItems centerContent mt-3'>
                {isLoadingMyListPostReported ? <div>Cargando...</div> :
                    myListPostReported && myListPostReported.map((postReported, index) => (
                        <div className="mb-2 row mr-3 ml-2 card-admin">
                            <div className="mb-2 mr-2 text-fz-1-5 text-bold">{postReported._id ||postReported.id}</div>
                            {postReported.reportState===3 && <div>En revision por el administrador </div>}
                            <div className="column">
                                {postReported.reportState!==3 && <div className="column"><div className="btn-red btns-admin ml-1" onClick={() => { changeMyListPostReported({id:postReported._id, reportState:2}, index) }}>Dejar inhabilitado</div>
                                <div className="btn-red btns-admin ml-1" onClick={() => { changeMyListPostReported({id:postReported._id, reportState:3}, index) }}>Mandar a revisión</div></div>}
                            </div>
                        </div>
                    ))
                }
            </div>

        </div>
    )

}
const mapStateToProps = (state) => {
    return {
        isLoadingMyListPostReported: state.userInfo.isLoadingMyListPostReported,
        myListPostReported: state.userInfo.myListPostReported
    }
}


export default connect(mapStateToProps, { getMyListPostReported,changeMyListPostReported })(SeeMyPostReported)
